<div class="modulo modulo-endereco">
  <h3 class="title-h3">{{data.titulo}}</h3>
  <article>
    {{data.params.endereco}}
  </article>  
  <div class="content-map" [innerHtml]="data.params.codigo_mapa | safeHtml"></div>
</div>
